import { BaseErrorBody, IBaseError, IBaseErrorConstructor } from './types';

export const BaseError: IBaseErrorConstructor = class BaseError<B>
  extends Error
  implements IBaseError<B>
{
  public body: BaseErrorBody<B>;

  public constructor(message: string, body: BaseErrorBody<B>) {
    super(message);
    this.name = 'BaseError';
    this.body = body;
  }
};
